import "./WebComponent/EthereumBlockies";

import "./octovault.scss";

const octoVault = require("./assets/images/octovault.svg");
const flexidao = require("./assets/images/flexidao-logo.svg");

// @ts-ignore
import { Elm }                                            from './OctoVault.elm';
import { getSignedTransactions, getComposedTransactions } from './utils/signTransaction'
import { Wallet }                                         from "ethers/wallet";
import { Dict }                                           from "./spring-types-src/generic/generic";

type ElmApp = {
    ports: Dict<{ send: Function, subscribe: Function }>,
};

function getQueryVariable(variable: string) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
}

const init = (): void => {

    let walletOptions = {
        scrypt: {
            N: (1 << 12) // The bigger the N, the more time needed to encrypt/decrypt.
        }
    };

    const app: ElmApp = Elm.OctoVault.init({
        flags: {
            allowedOrigin: getQueryVariable("origin") || null,
            storage: localStorage["storage"] || null,
            staticAssets: {
                octoVault,
                flexidao,
            },
            compactButtonLayout: getQueryVariable("compact-button-layout") === "true" || false,
        },
    });

    let currentWallet: any;

    function establishWallet(name: string, w: Wallet, keystore: any, responsePort: any) {
        const resp = [null, {
            name,
            address: w.address,
            keystore,
        }];
        responsePort.send(resp);
        currentWallet = w;
    }

    app.ports.alert.subscribe((msg: string) => {
        alert(msg)
    });

    app.ports.store.subscribe((storage: any) => {
        localStorage["storage"] = storage;
    });

    window.addEventListener("message", (event) => {
        // console.log("mesasge in octovault", event.data)
        app.ports.receiveMessage.send(event)
    }, false);

    app.ports.readFromSessionStorage && app.ports.readFromSessionStorage.subscribe((key: string) => {
        const value = sessionStorage[key] || "";
        app.ports.readFromSessionStorageResponse.send([key, value]);
    });


    app.ports.writeToSessionStorage && app.ports.writeToSessionStorage.subscribe(([key, value]: [string, any]) => {
        sessionStorage[key] = value;
    });

    app.ports.sendMessage.subscribe(([message, targetOrigin]: [string, string]) => {
        // console.log("message to send to client =", message);
        // console.log("targetOrigin =", targetOrigin);
        parent.postMessage(message, targetOrigin)
    });

    app.ports.log && app.ports.log.subscribe(console.debug);

    app.ports.open.subscribe(({ name, password, keystore }: any) => {
        const responsePort = app.ports.fetchResult;
        Wallet
            .fromEncryptedJson(keystore, password)
            .then((w: any) => {
                establishWallet(name, w, keystore, responsePort);
            })
            .catch((e: any) => {
                console.error(e);
                responsePort.send([e.toLocaleString(), null])
            })
    });

    app.ports.import_.subscribe(({ name, password, privateKey }: any) => {
        const responsePort = app.ports.fetchResult;
        try {
            let w = new Wallet(privateKey);
            w.encrypt(password, walletOptions)
                .then((keystore: any) => {
                    establishWallet(name, w, keystore, responsePort);
                })
                .catch((e: any) => {
                    console.error(e);
                    responsePort.send([e.toLocaleString(), null])
                })
        } catch (e) {
            responsePort.send([e.toLocaleString(), null])
        }

    });


    app.ports.create.subscribe(({ name, password }: any) => {
        const responsePort = app.ports.fetchResult;
        let w = Wallet.createRandom(walletOptions);
        w.encrypt(password, walletOptions)
            .then((keystore: any) => {
                establishWallet(name, w, keystore, responsePort);
            })
            .catch((e: any) => {
                console.error(e);
                responsePort.send([e.toLocaleString(), null])
            })
    });


    app.ports.signOnJs.subscribe(([requestId, message]: [string, string]) => {
        const responsePort = app.ports.signOnJsResult;
        currentWallet
            ? currentWallet
            .signMessage(message)
            .then((signedMsg: string) => {
                app.ports.signOnJsResult.send(["ok", requestId, signedMsg])
            })
            .catch((e: any) => {
                console.error(e);
                responsePort.send(["err", requestId, e.toLocaleString()])
            })
            : responsePort.send(["err", "OctoVault wallet is not open"])
    });


    app.ports.getSignedTransactions.subscribe(([batch, nonce]: [any, number]) => {
        const responsePort = app.ports.signedTransactions;
        const privateKey = currentWallet
            ? currentWallet.signingKey.privateKey
            : null;

        if (privateKey !== null) {
            getSignedTransactions(privateKey, batch, nonce)
                .then(transactions => {
                    responsePort.send(transactions);
                })
                .catch(err => {
                    console.error('error signing:', err);
                    const transactions = batch.map((transaction: any) => ({ ...transaction, msg: err }));
                    responsePort.send(transactions);
                })
        } else {
            const transactions = batch.map((transaction: any) => ({ ...transaction, msg: "Wallet is not open." }));
            responsePort.send(transactions);
        }

    });

    app.ports.getComposedTransactions.subscribe((msgs: any) => {
        const responsePort = app.ports.composedTransactions;
        const txWithFuncData = msgs.map((msg: any) => {
            const tx = getComposedTransactions(msg);
            return tx
        });
        responsePort.send(txWithFuncData);
    });

    app.ports.exportPrivateKey.subscribe(({ name, password, keystore }: any) => {
        const responsePort = app.ports.exportPrivateKeyResult;
        Wallet
            .fromEncryptedJson(keystore, password)
            .then((w: any) => {
                responsePort.send(w.privateKey);
            })
            .catch((e: any) => {
                console.error(e);
                responsePort.send(e.toLocaleString());
            })
    });

};

init();